import { render } from "./VehicleType.vue?vue&type=template&id=32b00857&scoped=true"
import script from "./VehicleType.vue?vue&type=script&lang=js"
export * from "./VehicleType.vue?vue&type=script&lang=js"

import "./VehicleType.vue?vue&type=style&index=0&id=32b00857&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b00857"]])

export default __exports__